import { LoggedUser } from '@cawita/core-front/auth';
import { CwtModel } from '@shared/modules/crud';
import { Address } from './address.model';

export type UserOrigin = 'facebook' | 'google' | 'credentials';

@CwtModel({ name: 'user', path: '/user' })
export class User extends LoggedUser {
    //----------------------------------------
    // General infos
    //----------------------------------------
    origin?: UserOrigin;
    email?: string;
    userSocialId?: string;
    password?: string;
    login?: string;
    firstName?: string;
    lastName?: string;
    picture?: string;
    civility?: string;
    language?: string;
    userSawTheTuto?: boolean;
    acceptNotif?: boolean;
    phone?: string;
    mobilePhone?: string;
    zipCode?: string;
    city?: string;
    country?: string;
    address?: Address;
    additionalAddress?: string;
    emailValid?: boolean;
    phoneValid?: boolean;
    creationDate?: Date;
    lastUpdateDate?: Date;
    isValid?: boolean;

    public fullName: string;

    constructor(json: any) {
        super(json);
        this.fullName = [this.firstName, this.lastName].filter(e => !e?.length).join(' ');
    }
}
